// CFO Core unified surface — telemetry event catalog.
// Every page, copilot rail, insight card, and depth disclosure should reference
// these constants so analytics stays consistent across the 10 calm pages.

/** Primary page surfaces (matches `activeSection` / `data-surface` on the shell). */
export const CFO_SURFACES = {
  ceo: 'cfo_ceo',
  ceoAnalysis: 'cfo_ceo_analysis',
  home: 'cfo_home',
  financials: 'cfo_financials',
  close: 'cfo_close',
  job_costing: 'cfo_job_costing',
  cash: 'cfo_cash',
  ratios: 'cfo_ratios',
  ar: 'cfo_ar',
  forecast: 'cfo_forecast',
  scenarios: 'cfo_scenarios',
  valuation: 'cfo_valuation',
  presentations: 'cfo_presentations',
  explore: 'cfo_explore',
  advanced: 'cfo_advanced',
} as const

export type CfoSurfaceId = keyof typeof CFO_SURFACES
export type CfoSurface = (typeof CFO_SURFACES)[CfoSurfaceId]

/** Canonical analytics event names for the unified CFO Core surface. */
export const CFO_EVENTS = {
  pageView: 'cfo_page_view',
  insightExplain: 'cfo_insight_explain',
  depthToggle: 'cfo_depth_toggle',
  exploreOpen: 'cfo_explore_open_surface',
  classicEscape: 'cfo_open_classic_view',
  ceoCockpitLoaded: 'ceo_cockpit_loaded',
  ceoPeriodChange: 'ceo_cockpit_period_change',
  ceoBasisChange: 'ceo_cockpit_basis_change',
  ceoLensChange: 'ceo_cockpit_lens_change',
  ceoDecisionDrill: 'ceo_decision_drill',
  ceoPanelOpen: 'ceo_panel_open',
  ceoNotTrackedCta: 'ceo_not_tracked_cta',
  ceoDemoCompanySwitch: 'ceo_demo_company_switch',
  /** A cockpit section threw during render and was replaced by its error boundary card. */
  ceoSectionError: 'ceo_section_error',
} as const

export type CfoTelemetryEvent = (typeof CFO_EVENTS)[keyof typeof CFO_EVENTS]

/** Sub-surfaces appended for feedback / bug report controls. */
export function cfoCopilotSurface(page: CfoSurface): string {
  return `${page}:copilot`
}

export function cfoInsightSurface(page: CfoSurface): string {
  return `${page}:insight`
}

export function cfoDepthSurface(page: CfoSurface): string {
  return `${page}:depth`
}
